import _ from 'underscore';
import {
  getRecommendationPreferences,
  saveRecommendationPreferences,
  recommendationInProductUpdateConfigs,
} from '@bingads-webui-campaign/recommendation-core';
import { IN_PRODUCT_UPDATE_RECOMMENDATIONS_VIEW_TIME } from '@bingads-webui-campaign/recommendation-preferences';

export function isShowNotificationBannerInTargetRecommendations(preferencesService, type) {
  const config = recommendationInProductUpdateConfigs[type];
  if (!_.isUndefined(config) &&
    !_.isUndefined(config.neverExpired) &&
    config.neverExpired === true) {
    return true;
  }
  const data = getRecommendationPreferences(preferencesService);
  const firstViewTime = data[IN_PRODUCT_UPDATE_RECOMMENDATIONS_VIEW_TIME.FirstViewTime];

  // if current time is more than 30 days after the first view time, disable it.
  if (firstViewTime && firstViewTime[type]) {
    return (Date.now() - firstViewTime[type]) < 30 * 24 * 3600 * 1000;
  }
  return false;
}

export function judgeWhetherUserFirstViewNotificationBanner(preferencesService, type) {
  const data = getRecommendationPreferences(preferencesService);
  const firstViewTime =
    data[IN_PRODUCT_UPDATE_RECOMMENDATIONS_VIEW_TIME.FirstViewTime]; // true if viewed

  // we would restore for all types of recommendations
  return _.isUndefined(firstViewTime) || _.isUndefined(firstViewTime[type]);
}

export function recordUserFirstViewTimeOfNotificationBanner(preferencesService, type) {
  // for e.g. firstViewTime[RAD] = 100000000, save into preference for that user
  saveRecommendationPreferences(
    {
      [IN_PRODUCT_UPDATE_RECOMMENDATIONS_VIEW_TIME.FirstViewTime]: { [type]: Date.now() },
    },
    preferencesService
  );
}

export function isInProductUpdateBannerAvailable(type, permissions, summary) {
  if (recommendationInProductUpdateConfigs[type]) {
    const config = recommendationInProductUpdateConfigs[type];
    return (permissions[config.permission] && summary[config.available]);
  }
  return false;
}

export function isAdditionalPitchingAvailable(type, permissions, summary) {
  if (recommendationInProductUpdateConfigs[type]) {
    const config = recommendationInProductUpdateConfigs[type];
    if (config.additionalPitchingEnabledBy === 'permission') {
      return permissions[config.permission];
    } else if (config.additionalPitchingEnabledBy === 'available') {
      return summary[config.available];
    }
    return false;
  }
  return false;
}
